import { z } from 'zod';

// The shape the browser hands back from PushManager.subscribe(), narrowed to the
// three fields the server needs. `expirationTime` is deliberately ignored: it is
// null on every engine that ships Web Push today.
export const PushSubscribeSchema = z.object({
  endpoint: z.string().url().max(2000),
  keys: z.object({
    p256dh: z.string().min(1).max(255),
    auth: z.string().min(1).max(255),
  }),
});

export const PushUnsubscribeSchema = z.object({
  endpoint: z.string().url().max(2000),
});

export const PushPublicKeyResponseSchema = z.object({
  // null when the server has no VAPID pair configured, which is how the client
  // knows to render the push section as unavailable instead of failing a subscribe.
  publicKey: z.string().nullable(),
});

export const PushSubscriptionSummarySchema = z.object({
  id: z.string().uuid(),
  endpoint: z.string(),
  userAgent: z.string().nullable(),
  createdAt: z.string(),
  lastSuccessAt: z.string().nullable(),
});

export type PushSubscribeBody = z.infer<typeof PushSubscribeSchema>;
export type PushUnsubscribeBody = z.infer<typeof PushUnsubscribeSchema>;
export type PushPublicKeyResponse = z.infer<typeof PushPublicKeyResponseSchema>;
export type PushSubscriptionSummary = z.infer<typeof PushSubscriptionSummarySchema>;
